"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __param = (this && this.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TransferService = void 0;
/**
 * Transfer Service file
 */
const Identifiers_1 = require("./../../lib/constant/Identifiers");
const inversify_1 = require("inversify");
require("reflect-metadata");
const operators_1 = require("rxjs/operators");
/**
 * Implementation
 */
let TransferService = class TransferService {
    constructor(gateway, antiFraud) {
        this._gateway = gateway;
        this._antiFraud = antiFraud;
    }
    requestTransferToken(request, mid, isTest, regional) {
        return this._gateway.requestMerchantSettings(mid, isTest, regional).pipe(operators_1.switchMap((merchant) => {
            const client = request.documentNumber !== undefined
                ? request.documentNumber
                : new Date().getTime().toString();
            return this._antiFraud.createSiftScienceSession(request.bankId, client, mid, isTest, merchant);
        }), operators_1.switchMap((siftObject) => this._gateway.requestTransferToken(Object.assign(Object.assign({}, request), siftObject), mid, isTest, regional)));
    }
    requestBankList(mid, isTest, regional) {
        return this._gateway.requestPseBankList(mid, isTest, regional);
    }
};
TransferService = __decorate([
    inversify_1.injectable(),
    __param(0, inversify_1.inject(Identifiers_1.IDENTIFIERS.KushkiGateway)),
    __param(1, inversify_1.inject(Identifiers_1.IDENTIFIERS.AntiFraud)),
    __metadata("design:paramtypes", [Object, Object])
], TransferService);
exports.TransferService = TransferService;
